

















































import {Component, Prop, Vue} from 'vue-property-decorator'
import { Action } from 'vuex-class'
import AuthRequest from '../../model/request/AuthRequest'
import moment from 'moment'
import * as Helper from '@/helpers'

@Component
export default class CodeValidation extends Vue {
  @Action('auth/validateCode') validateCode!: Function
  @Action('auth/sendCode') sendCode!: Function

  request = new AuthRequest()

  timer = ''
  startTime: moment.Moment = moment()
  endTime: moment.Moment | null = null

  async mounted() {
    if (!this.$route.params.user || !this.$route.params.password) {
      this.$router.push('/sign-in')
      return
    }

    this.request.cnpj = this.$route.params.user
    this.request.senha = this.$route.params.password

    await this.sendCode(this.request)

    this.startTime = moment()
    this.endTime = moment().add(5, 'minutes')
    await this.updateTime()
  }

  get isCodeExpired() {
    return !this.endTime
  }

  async updateTime() {
    if (!this.endTime) return

    const remainingTimeInSeconds = this.endTime.diff(moment(), 'seconds')

    if (remainingTimeInSeconds <= 0) {
      this.timer = '00:00'
      this.endTime = null
      return
    }

    const hour = Math.floor(remainingTimeInSeconds / 3600)
    const minutes = Math.floor((remainingTimeInSeconds - hour * 3600) / 60)
    const seconds = Math.floor(remainingTimeInSeconds % 60)

    const date = moment().minutes(minutes).seconds(seconds).format('mm:ss')

    if (moment(date, 'mm:ss', true).isValid()) {
      this.timer = date
    } else {
      this.timer = '00:00'
      this.endTime = null
      return
    }

    await Helper.sleep(1000)
    await this.updateTime()
  }

  async handleResendCode(request: AuthRequest) {
    await this.sendCode(request)
    this.startTime = moment()
    this.endTime = moment().add(5, 'minutes')
    await this.updateTime()
  }
}
